import {Component, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectAssociationContext, CustomObjectTypeSearchModel} from "../custom-object-type-search.model";
import {
    CustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/custom-object-type-search-page.component";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    InventoryCustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/inventory-custom-object-type-search-page.component";
import {
    ProductLineCustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/product-line-custom-object-type-search-page.component";
import {
    OutletCustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/outlet-custom-object-type-search-page.component";
import {
    MembershipTypeCustomObjectTypeSearchPageComponent
} from "../custom-object-type-search-page/membership-type-custom-object-type-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-custom-object-type-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(CustomObjectTypeSearchModel),
        registerSearchControl(CustomObjectTypeMultiSelectSearchControlComponent)
    ]
})
export class CustomObjectTypeMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<CustomObjectTypeSearchModel> implements OnInit {
    @Input() productLineContext: boolean;
    @Input() inventoryContext: boolean;
    @Input() outletContext: boolean;
    @Input() membershipTypeContext: boolean;

    constructor(model: CustomObjectTypeSearchModel, injector: Injector) {
        super(model, injector, "customObjectTypeId", "name");
    }

    ngOnInit(): void {
        if (this.productLineContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.PRODUCT_LINE;
            this.extendedSearchComponent = ProductLineCustomObjectTypeSearchPageComponent;
        } else if (this.inventoryContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.INVENTORY;
            this.extendedSearchComponent = InventoryCustomObjectTypeSearchPageComponent;
        } else if (this.outletContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.OUTLET;
            this.extendedSearchComponent = OutletCustomObjectTypeSearchPageComponent;
        } else if (this.membershipTypeContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.MEMBERSHIP_TYPE;
            this.extendedSearchComponent = MembershipTypeCustomObjectTypeSearchPageComponent;
        } else {
            this.extendedSearchComponent = CustomObjectTypeSearchPageComponent;
        }
    }
}
